import React from "react";
import { DataState } from "./useData";
import { isPromise } from "../utils/conversion";


export function useApi<Result>(
	props: {
		request: () => Promise<any> | undefined,

		condition?: boolean,
		
		// gives chance to modify data before its stored
		prepareResult?: (result: any) => Result,

		// if return from request is to be the value of the data state then use this option so its auto set
		data?: DataState<Result>,
	}, 
	deps: any[]
) {

	const [value, setValue] = React.useState<Result>();

	React.useEffect(() => {
		if (props.condition !== undefined && !props.condition) return;

		const prom = props.request();
		if (!prom) return;

		// if something other than a promise was returned then treat it as the new value
		if (!isPromise(prom)) {
			setValue(prom as any);
			return;
		}

		prom.then((resp: any) => {
			let result = resp;
			if (props.prepareResult) {
				result = props.prepareResult(result);
			}

			if (props.data) {
				props.data.value = result;

				// also run an initial validate
				props.data.validate();
			}

			setValue(result);

		}).catch(() => {
			// notification already generated in api 
		})
	}, deps);

	return value;
}
